import { Component, Input } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-grid-header',
  templateUrl: './grid-header.component.html',
  styleUrl: './grid-header.component.scss',
})
export class GridHeaderComponent {
  @Input() header: string;
  @Input() fields: FormlyFieldConfig[];
  @Input() model: any = {};
  @Input() labelsVertical = false;
}
